// extracted by mini-css-extract-plugin
export default {"container":"header-tooltip_container__ZEQ2x","item":"header-tooltip_item__XBVSU","visible":"header-tooltip_visible__kGEgw"};